module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/info_prompt@1x.png?1.0.17";